export class StripSubscriptionDetails {
  amount?: number;
  currency?: string;
  connected_account_id?: string;
  automatic_payment_methods?: any;
  payment_method_types?: string[];
  description?: string; // Booked service names, shown on the Stripe PaymentIntent
  metadata?: {
    // User metadata
    email?: string; // Email
    prename?: string; // Prename
    lastname?: string; // Lastname
    phone?: string; // Phone
    mobile?: string; // Mobile

    // Partner metadata
    partner_id?: number;
    partner_name?: string;

    // Booking metadata (what was paid for)
    widget_type?: string; // Always 'smart_widget', so Smart-Widget payments are distinguishable from booking-widget ones
    service_names?: string; // Booked service names, comma separated
    service_ids?: string; // Booked service ids, comma separated

    // Coupon metadata
    coupon_id?: number; // Coupon ID
    original_amount?: number; // Original amount
    coupon_code?: string; // Coupon code
    is_fixed_amount?: number; // Is fixed amount
    is_percentage?: number; // Is percentage
    coupon_amount?: number; // Coupon amount
    coupon_percentage?: number; // Coupon percentage
    coupon_final_discount?: number; // Coupon final discount
    coupon_discount_amount?: number; // Price after coupon reduction
  };

  // Strip payment intent update
  payment_intent_id?: string
}